import React from "react";
import { Input } from "components/Graphs/Input";
import EnvironmentRefreshButton from "components/Environment/shared/EnvironmentRefreshButton";
import AppliedFilterChips from "./AppliedFilterChips";
import ComputeFilters from "./ComputeFilters";
import type {
  ComputeListFilters,
  ComputeListFilterUpdate,
} from "./hooks/useComputeListFilters";
import type { TeamMember } from "./hooks/useOrganizationTeamMembers";
import type { EnvironmentListTab } from "./EnvironmentListTabs";

interface ComputeListControlsProps {
  activeTab: EnvironmentListTab;
  creatorLabel?: string;
  currentUserId?: string;
  filters: ComputeListFilters;
  isRefreshing: boolean;
  members: TeamMember[];
  onRefresh: () => void;
  search: string;
  setFilters: (filters: ComputeListFilterUpdate) => void;
  setSearch: (search: string) => void;
  show: boolean;
}

const ComputeListControls: React.FC<ComputeListControlsProps> = ({
  activeTab,
  creatorLabel,
  currentUserId,
  filters,
  isRefreshing,
  members,
  onRefresh,
  search,
  setFilters,
  setSearch,
  show,
}) => {
  const computeFiltersEnabled = activeTab === "compute";

  return (
    <div className="pt-6">
      <div className="flex flex-wrap items-center gap-3">
        {show && computeFiltersEnabled ? (
          <ComputeFilters
            members={members}
            currentUserId={currentUserId}
            filters={filters}
            setFilters={setFilters}
          />
        ) : null}
        {show ? (
          <Input
            type="search"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder={
              activeTab === "compute" ? "Search compute" : "Search applications"
            }
            className="min-w-[220px] flex-1 max-w-sm"
            inputClassName="border-zinc-700 bg-primaryBg py-1.5 text-white placeholder:text-secondary"
          />
        ) : null}
        {show ? (
          <EnvironmentRefreshButton
            isRefreshing={isRefreshing}
            onRefresh={onRefresh}
            className="h-[30px] border-zinc-700 bg-zinc-900/40 px-3 py-0 text-sm font-normal text-secondary hover:border-zinc-500 hover:bg-zinc-800 hover:text-white"
          />
        ) : null}
      </div>
      {show && computeFiltersEnabled ? (
        <AppliedFilterChips
          creatorLabel={creatorLabel}
          filters={filters}
          setFilters={setFilters}
        />
      ) : null}
    </div>
  );
};

export default ComputeListControls;
